import { acceptPk, delPk } from "@api/user";
import dialog from "@utils/dialog";

export function cancelPkHandle(id) {
  return new Promise((resolve, reject) => {
    dialog.confirm({
      mes: "确认删除这个PK?",
      opts() {
        delPk(id)
          .then(res => {
            dialog.success("删除成功");
            resolve(res);
          })
          .catch(err => {
            dialog.error("删除失败");
            reject(err);
          });
      }
    });
  });
}

export function acceptPkHandle(id) {
  return new Promise((resolve, reject) => {
    dialog.confirm({
      mes: "确定接受这个PK?",
      opts() {
        acceptPk(id)
          .then(res => {
            dialog.success("接受成功");
            resolve(res);
          })
          .catch(err => {
            console.log(err);
            if (err.msg) {
              dialog.error(err.msg);
            } else {
              dialog.error("接受失败");
            }
            reject(err);
          });
      }
    });
  });
}
